import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  WebAppProcessPlanning,
  EcommerceWebProcessUIUX,
  EcommerceWebProcessFrontend,
  EcommerceWebProcessQuality,
  WebAppProcessBackend,
} from "../../../app-constants";
import BgImg from "../../images/services-usa/web-app-dev/agile_process.webp";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Agile <span>Web Application Development</span> Process
            </h2>
            <p>
              Being an internationally appreciated company specializing in web
              app development services, we employ a polished, iterative process
              that turns ideas into cost-effective, secure web applications.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Understanding Project Requirements</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>
                First of all, we need to identify the purpose of your project,
                your audience, the required features, and any specific
                conditions. To collect detailed information, the expert team
                performs consultation, and market and competitor analysis. This
                approach helps us lay down the right foundation that will lead
                to the success of your web application.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Planning and Wireframing</h5>
                </div>
                <div className="ecom_box_icon">{WebAppProcessPlanning}</div>
              </div>
              <p>
                They go through each application feature and construct
                wireframes that depict the flow of users and the layout of the
                interfaces. We use interactive prototypes to create a clickable
                model, where the key stakeholders can test the app during design
                conception. Such an approach allows for refining ideas and
                avoiding costly overhauls and changes in the future.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>UI/UX Design</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessUIUX}</div>
              </div>
              <p>
                We provide elegant and innovative concepts that allow for easy
                and enjoyable navigation for the user. Our skilled designers
                combine style with practicality and follow modern trends and web
                content accessibility guidelines. We pay particular attention to
                a layout that is suitable for all devices to increase customer
                satisfaction and loyalty.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Frontend Development</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessFrontend}
                </div>
              </div>
              <p>
                As front-end specialists, we develop access-friendly and
                engaging interfaces employing new web standards. We utilize
                modern frameworks and libraries that give rise to engaging and
                efficient UI designs. Our code adds up speed with interaction
                and fast loading times in different platforms and browsers used
                today.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Backend Development</h5>
                </div>
                <div className="ecom_box_icon">{WebAppProcessBackend}</div>
              </div>
              <p>
                We build complex high-performance back-ends that are the
                foundation of your web application. Our developers employ strong
                programming languages and frameworks to produce reliable
                back-end parts. We use modern database management systems, APIs,
                and cloud services to make your application scalable and capable
                of performing complex operations.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Testing and Quality Assurance</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Thorough cross-browser and cross-platform testing guarantee a
                perfect performance of the application. Automated and manual
                testing techniques used by our QA team help to find out and fix
                problems. We also perform cross-browser, cross-device, and
                performance testing to ensure your application operates
                optimally in different scenarios.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          ></Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
